//CONTANTS ALSO INCLUDED IN THIS FILE
export const SORT_BY_DROP_VALUES = [{ "id": "lowhigh", "value": "Price (low to high)" }, { "id": "highlow", "value": "Price (high to low)" }, { "id": "AZ", "value": "Product A to Z " }, { "id": "ZA", "value": "Product Z to A" }]

export const formatNumberWithCommas = (number) => {
  return new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(number);
}



export const formatDate = (date, format = 'dd.mm.yyyy', time = false) => {
  if (!date) return '';
  if(date === "-") return "-";

  // Ensure the date is a valid Date object
  if (!(date instanceof Date)) {
    date = new Date(date);
    if (isNaN(date)) return 'Invalid Date';
  }

  const day = date.getDate().toString().padStart(2, '0');
  const month = date.getMonth(); // 0-11 index
  const year = date.getFullYear().toString();
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');


  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  let formattedDate = '';

  switch (format) {
      case 'yyyy-mm-dd':
          formattedDate = `${year}-${(month + 1).toString().padStart(2, '0')}-${day}`;
          break;
      case 'dd/mm/yyyy':
          formattedDate = `${day}/${(month + 1).toString().padStart(2, '0')}/${year}`;
          break;
      case 'dd-MMM-yyyy':
          formattedDate = `${day}-${monthNames[month]}-${year}`;
          break;
      case 'yyyy':
            formattedDate = `${year}`;
            break;    
      default:
          formattedDate = `${day}.${(month + 1).toString().padStart(2, '0')}.${year}`;
          break;
  }

  // Include time if specified
  if (time) {
    formattedDate += ` ${hours}:${minutes}`;
  }

  return formattedDate;
};

// Utility function to get order metadata (date, time with timezone, and IP address)
export const getOrderMetadata = async () => {
  const dateTimeFull = new Date();
  
  // Get date
  const createdDate = formatDate(dateTimeFull, 'dd-MMM-yyyy');
  
  // Get time with timezone
  const hours = dateTimeFull.getHours().toString().padStart(2, '0');
  const minutes = dateTimeFull.getMinutes().toString().padStart(2, '0');
  const seconds = dateTimeFull.getSeconds().toString().padStart(2, '0');
  // const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const timeZoneAbbr = new Date().toLocaleTimeString('en-US', { timeZoneName: 'short' }).split(' ')[2];
  const createdTime = `${hours}:${minutes}:${seconds}(${timeZoneAbbr})`;
  
  return {
    createdDate,
    createdTime,
    dateTimeFull
  };
};

// Utility function to split datetime from field_order_created_date
export const splitOrderDateTime = (orderCreatedDate: string) => {
  if (!orderCreatedDate) {
    return { date: '', time: '' };
  }

  try {
    // Parse the MySQL datetime format (YYYY-MM-DD HH:MM:SS) or ISO format
    const dateObj = new Date(orderCreatedDate);
    
    if (isNaN(dateObj.getTime())) {
      return { date: '', time: '' };
    }
    
    // Get formatted date (dd-MMM-yyyy)
    const date = formatDate(dateObj, 'dd-MMM-yyyy');
    
    // Get time with timezone
    const hours = dateObj.getHours().toString().padStart(2, '0');
    const minutes = dateObj.getMinutes().toString().padStart(2, '0');
    const seconds = dateObj.getSeconds().toString().padStart(2, '0');
    const timeZoneAbbr = new Date().toLocaleTimeString('en-US', { timeZoneName: 'short' }).split(' ')[2];
    const time = `${hours}:${minutes}:${seconds}(${timeZoneAbbr})`;
    
    return { date, time };
  } catch (error) {
    console.error('Error parsing order created date:', error);
    return { date: '', time: '' };
  }
};

// Utility function to calculate expiry date
export const calculateExpiryDate = (approved_date, expiryDate) => {
  // If expiryDate is provided, return it as a Date object. Otherwise, calculate expiry date as 3 months from approved_date.
  if (expiryDate !== null && expiryDate !== undefined && expiryDate !== "") {
      return new Date(expiryDate);
  }
  // Calculate new expiry date as 3 months from approved_date
  const newExpiryDate = new Date(approved_date);
  newExpiryDate.setMonth(newExpiryDate.getMonth() + 3);
  return newExpiryDate;
};


//update few paramaters of offers before displaying in the below
export const updatedOffersList = (data) => {
  const updateData = !!data && data.length > 0 && data.map((item) => {
    
    const createdDate = item.offer_created_date ? new Date(item.offer_created_date) : new Date(item.createdAt);
    const approved_date = item.field_ofr_order_approved_date ? new Date(item.field_ofr_order_approved_date) : null;
    const expiryDate = item.field_offer_expiry_date !== null ? new Date(item.field_offer_expiry_date) : null;

    const formattedDate = formatDate(createdDate, 'dd-MMM-yyyy');
    // Previous logic which was incorrect as it was taking created date instead of approved date for calculation of expiry date - Kept for reference
    // const formattedExpDate = formatDate(calculateExpiryDate(createdDate, expiryDate), 'dd-MMM-yyyy');
    
    // The field_ofr_order_approved_date is considered for calculation of expiry date as per the new understanding of the data fields
    // If both approved_date and expiryDate are null, set formattedExpDate to an empty string. Otherwise, calculate and format the expiry date.
    const formattedExpDate = (approved_date === null && expiryDate === null) ? '' : formatDate(calculateExpiryDate(approved_date, expiryDate), 'dd-MMM-yyyy');

    // Format the cost with commas and append the currency
    const formattedCost = `${formatNumberWithCommas(item.field_ofr_order_cart_total)} ${item.field_ofr_order_currency}`
    return {
      ...item,
      offer_created_date: formattedDate,
      offer_expiry_date: formattedExpDate,
      cost: formattedCost
    };
  });

  return updateData;
};






//Optimized function to get the merchant logo from azure with help of supplier id
export const getSupplierImage = (is_agent_model, supplier_id) => {
  let base_path = process.env.REACT_APP_BLOB_PATH_PRODUCT
  if (is_agent_model === 0) {
    return base_path + "nokia.png";
  }
  
  if (is_agent_model === 1 && supplier_id) {
    let supplierLogo = base_path + supplier_id + ".png";
    return supplierLogo;
  }
  
  return '';
};

//get fulfillMent type
export const getFulFillmentType = (product) => {
  let shipmentType = '';
  if (product.is_agent_model === 1) {
    if (product.fulfillment_mode === 'Merchant') {
      shipmentType = product.supplier_text;
    } else if (product.fulfillment_mode === 'DAC') {
      shipmentType = "Nokia";
    } else {
      shipmentType = "";
    }
  } else {
    shipmentType = "Nokia";
  }
  return shipmentType;
}

export function getAccountCurrency(currency, currencyIsoCode) {
  if (currency !== null) {
    return currency;
  } else if (currencyIsoCode === 'USD' || currencyIsoCode === 'JPY') {
    return currencyIsoCode;
  } else if (currencyIsoCode === 'AUD' || currencyIsoCode === 'MXN' || currencyIsoCode === 'CAD') {
    return 'USD'
  }
  else {
    return 'EUR';
  }
}

export const shortenText = (text, size = 25, suffix = "...") => {
  if (text.length > size) {
    return text.substring(0, (size - suffix.length)) + suffix;
  } else {
    return text;
  }
}

export const getSoldByInfo = (product) => {
  let soldBy = "";
  if (product.is_agent_model === 1) {
    soldBy = product.supplier_text
  } else if (product.is_agent_model === 0) {
    soldBy = "Nokia"
  } else {
    soldBy = ""
  }
  return soldBy;
}

export const getSupportedByInfo = (product) => {
  let supportedBy = "";
  if(product.is_agent_model === 1 && (product.technical_support_type === "Merchant" || product.technical_support_type === null || product.technical_support_type === "")){
    supportedBy = product.supplier_text
  } else if((product.is_agent_model === 1 && product.technical_support_type === "DAC") || product.is_agent_model === 0){
    supportedBy = "Nokia"
  }
  return supportedBy;
}

export const  getImageHeight = (supplier_text) => {
  if (supplier_text?.toLowerCase().includes('etra') || supplier_text?.toLowerCase().includes('nordic') || supplier_text?.toLowerCase().includes('multi-tech')) {
    return true;
  } else {
    return false;
  }

}


//a common method to segregate the products based on agent model(Nokia/Merchant)
export function splitProductsByAgentModel(products) {
  const nokiaProducts = products.filter(product => product.is_agent_model === 0);
  const merchantProducts = products.filter(product => product.is_agent_model !== 0);

  return { nokiaProducts, merchantProducts };
}

export function salesChannelMapping() {
  const salesMap = {
    "Direct Reseller Partner": "RES",
    "End Customer": "",
    "DIRECT CUSTOMER": "DIR",
    "GLOBAL SYSTEM INTEGRATOR": "RES",
    "INDUSTRIAL PARTNER": "RES",
    "Indirect Reseller Partner": "RES",
    "Distributor": "DIS",
    "INTEGRATOR": "RES",
    "Service Provider Partner": "RES",
    "Direct": "DIR",
    "PROJECT SPECIFIC": "",
    "Vendor": "",
    "Services Partner": "RES",
    "Advisor Partner": "RES",
    "SW INTEGRATOR": "RES"
  };
  return salesMap;
}